<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Party building</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  {{ menu.title }} >  {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-left">
          <div class="survey-module-left-action">
            <div class="survey-module-left-title justify-center align-center">{{ menu.title }}</div>
            <div class="survey-module-left-item" 
              v-for="(item,index) in menu.list" 
              :key="index" 
              :class="menu_id==item.id?'survey-module-left-item-select':''" 
              @click="menuFun(item.id)"
            >
              <div class="survey-module-left-child justify-center align-center">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="survey-module-right" v-show="!detail_show">
          <div class="survey-module-right-title f-w">
            {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
          </div>
          <div class="survey-module-right-action">
            <div class="new-list" v-if="menu_action.length>0">
              <div class="new-item justify-between" v-for="(item,index) in menu_action" :key="index" @click="openDetail(item)">
                <div class="new-item-img-box">
                  <img :src="$baseUrl+item.thumbnailUrl" alt="">
                </div>
                <div class="new-item-content flex-col justify-between">
                  <span class="new-item-content-title">{{ item.title }}</span>
                  <span>{{ item.synopsis }}</span>
                  <span>{{ item.createTime }}</span>
                </div> 
              </div>
              <div class="pagination-content justify-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  layout="total,prev, pager, next, jumper"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
              </div>
            </div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
        <div class="survey-module-right" v-show="detail_show">
          <div class="survey-module-right-title f-w justify-between">
            <span>{{ detail_obj.title }}</span>
            <span class="justify-end">{{ detail_obj.createTime }}</span>
          </div>
          <div class="survey-module-right-action">
            <div class="new-detail" v-html="detail_obj.content" v-if="detail_obj.content"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getList} from "@/api/dj_or_xhdt";
export default {
  data(){
    return{
      menu:{
        title:this.$wangzhan.name=='安徽'?'学会党建':'协会党建',
        list:[
          {name:'党建',id:'1'},
        ]
      },
      menu_id:this.$route.query.id,
      menu_action:[],
      queryParams:{
        pageNum: 1,
        pageSize: 10,
        title: "",
        type: "part",
      },
      total:0,
       // 详情
       detail_show:false,
       detail_obj:{
         title:'',
         content:'',
         createTime:''
       }
    }
  },
  created(){
    this.getFun()
  },
  methods:{
    menuFun(id){
      this.menu_id = id
      this.detail_show = false
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.getFun()
    },
    getFun(){
      getList(this.queryParams)
      .then(({ data }) => {
        this.menu_action = data.list;
        this.total = data.total;
      })
      .finally(() => {});
    },
    // openDetail(id){
    //  let name = this.menu.list[this.menu.list.findIndex( item => item.id == this.menu_id)].name
    //   let pathHerf = this.$router.resolve({
    //     path:'/detailPage',query:{detail_id:id,type:1,name}
    //   })
    //   window.open(pathHerf.href, '_blank');
    // }
    openDetail(row){
      this.detail_show = true
      this.detail_obj = row
      this.detail_obj.content = this.detail_obj.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
      this.detail_obj.content = this.detail_obj.content.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
      window.scrollTo(0,0);
    }
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style scoped>

</style>
